/**
 * @package soulgood-custom
 *
 * Entry point for Javascript package
 */

import setHeroStyling from './misc/setHeroStyling';
import initHeaderScroll from './misc/headerScrollEffect';
import MenuController from './misc/menuController';

// Initialize the application
// Start all required functions in here
function soulInit() {
  // @ts-ignore Initialize lazy loading
  new LazyLoad();

  // Set hero section size
  setHeroStyling();

  // Init header scroll effect
  initHeaderScroll();

  const menuButton = document.querySelector('.header__nav--mobile>svg');
  const menuWrapper = document.querySelector('.header__menu--mobile');

  // @ts-ignore initialize menu controller
  new MenuController(menuWrapper, menuButton);
}

// Check if polyfill loading is needed
if (
  'fetch' in window
  && 'Intl' in window
  && 'URL' in window
  && 'Map' in window
  && 'forEach' in NodeList.prototype
  && 'startsWith' in String.prototype
  && 'endsWith' in String.prototype
  && 'includes' in String.prototype
  && 'includes' in Array.prototype
  && 'assign' in Object
  && 'entries' in Object
  && 'keys' in Object
) {
  soulInit();
} else {
  // @ts-ignore Load polyfills
  import('./polyfills.ts').then(soulInit);
}
